import { createHashParams } from '../../utils';
import type { RedirectHashParams } from '../../types/hashParams';

export function useNavigateToApps() {
  const createAppUrl = (
    redirectURL: string,
    hashParams: RedirectHashParams
  ) => {
    const url = new URL(redirectURL);

    /**
     * What does it check?
     * It checks whether a URL has an existing hash.
     * If it has then it appends the hashParams starting with &.
     * If it does not it creates a hashParams.
     *
     * For example:
     * const urlWithHash = https://portal.com/#?someHashKey=someHashValue
     * Output =  https://portal.com/#?someHashKey=someHashValue&someOtherHashKey-someOtherHashValue

     * const urlWithoutHash =  https://portal.com
     * Output =  https://portal.com/#?someHashKey=someHashValue&someOtherHashKey-someOtherHashValue
     */
    const hasExistingHash = url.hash ? url.hash.substring(1) : '';

    url.hash = !!hasExistingHash
      ? `?${hasExistingHash}&${createHashParams(hashParams)}`
      : `#?${createHashParams(hashParams)}`;

    return url.toString();
  };

  return {
    createAppUrl,
  };
}
